import { Outlet, ScrollRestoration, useNavigation } from "react-router";
import { UpdateBanner } from "./UpdateBanner";

/** Root of every route: update banner, a thin progress bar while the next screen's chunk loads, scroll restore. */
export function AppFrame() {
  const navigation = useNavigation();
  const loading = navigation.state === "loading";
  return (
    <>
      <div className="app-progress" data-active={loading || undefined} role="progressbar" aria-label="Carregando a próxima tela" aria-hidden={!loading} />
      <UpdateBanner />
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
